/* eslint-disable */
import { combineReducers } from 'redux';

// Constants Types
// ET - Early terminate
import {
  PATIENT_REVOKE_REQUEST,
  PATIENT_REVOKE_SUCCESS,
  PATIENT_REVOKE_FAILURE,
  PATIENT_ET_REQUEST,
  PATIENT_ET_SUCCESS,
  PATIENT_ET_FAILURE,
} from './types';

const initialState = {
  isRequesting: false,
  revoked: false,
  earlyTerminated: false,
  error: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PATIENT_REVOKE_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [PATIENT_REVOKE_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    revoked: true,
  }),
  [PATIENT_REVOKE_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    revoked: false,
    error: action.payload,
  }),
  [PATIENT_ET_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [PATIENT_ET_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    earlyTerminated: true,
  }),
  [PATIENT_ET_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    earlyTerminated: false,
    error: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
const PatientRevoke = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default combineReducers({
  patientRevoke: PatientRevoke,
});



// WEBPACK FOOTER //
// ./src/views/state/IdtfRevokeET/IdtfRevokeETReducers.js